import { render, staticRenderFns } from "./FacultativeDetailView.vue?vue&type=template&id=57cdad33&scoped=true&"
import script from "./FacultativeDetailView.vue?vue&type=script&lang=js&"
export * from "./FacultativeDetailView.vue?vue&type=script&lang=js&"
import style0 from "./FacultativeDetailView.vue?vue&type=style&index=0&id=57cdad33&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdad33",
  null
  
)

export default component.exports